/**
 * @generated SignedSource<<cf810f432bfecbd1165c195ae9a35696>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type moduleRatingsTable_ModuleRatingCalculationInlineFragment$data = {
  readonly amount: any;
  readonly node: {
    readonly id: string;
    readonly structureDefinition: {
      readonly title: string;
    };
  } | null | undefined;
  readonly nodeRef: string;
  readonly score: number;
  readonly " $fragmentType": "moduleRatingsTable_ModuleRatingCalculationInlineFragment";
};
export type moduleRatingsTable_ModuleRatingCalculationInlineFragment$key = {
  readonly " $data"?: moduleRatingsTable_ModuleRatingCalculationInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"moduleRatingsTable_ModuleRatingCalculationInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "moduleRatingsTable_ModuleRatingCalculationInlineFragment"
};

(node as any).hash = "7b55389ecdea143c1966193b87bdf827";

export default node;
